import { memo } from 'react';
import { CircularProgress } from '@mui/material';

import { BackdropLoaderRoot } from './BackdropLoader.style';

interface BackdropLoaderProps {
  isLoading: boolean;
  isPlane?: boolean;
  size?: number;
}

function BackdropLoader(props: BackdropLoaderProps) {
  const { isLoading, isPlane, size = 48 } = props;

  if (!isLoading) {
    return null;
  }

  return (
    <BackdropLoaderRoot isPlane={isPlane}>
      <CircularProgress disableShrink size={size} variant="indeterminate" />
    </BackdropLoaderRoot>
  );
}

export default memo(BackdropLoader);
